@if (initialAuthenticationSucceeded()) {
  <router-outlet />
}
